import { render, staticRenderFns } from "./VConsumptionForm.vue?vue&type=template&id=21bcead6&"
import script from "./VConsumptionForm.vue?vue&type=script&lang=js&"
export * from "./VConsumptionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports